import React , {useState, useEffect} from "react";
import sixDotIcon from "../../images/6doticon.svg";
import sixDotIconGrayedOut from "../../images/6doticonGreyedOut.svg";
import moduleWarning from "../../images/module_warning.svg";
import Tooltip from "@mui/material/Tooltip";
import QualifiersModal from "./QualifiersModal";
import FootnoteSymbolModal from "../Editor/FootnoteSymbolModal";
import InfoIconWarning from "../../images/infoIconFootNotesWarning.svg";
import expiredStatus from "../../images/expired status.svg";
import available from "../../images/ApproveIcon.svg";

const BulletPointTitle = ({ title, className = "matchText" }) => {
  return (
    <div
      className={className}
      style={{ display: "flex", alignItems: "center" }}
    >
      <span style={{ marginRight: "8px", fontSize: "20px" }}>•</span>
      {title}
    </div>
  );
};
const AssociatedCard = ({
  claim,
  reusableText,
  component,
  sendAtomDetails2Canvas,
  index,
  modulesArray,
  droppedComponentIds,
  droppedTextIds,
  droppedTitleIds,
  claimsArray,
  notUsedEditorToggle,
  isReferenceFootnotes,
  reusableTextIdsArray,
  length,
  setComponentAssignClicked,
  componentAssignClicked,
  setClaimAssignClicked,
  claimAssignClicked,
  openQualifiersModal,
  setOpenQualifiersModal,
  setSelectedClaimIndex,
  setSelectedRelatedClaimIndex,
  setExpandModuleQualifiers,
  selectedClaimIndex,
  selectedRelatedClaimIndex,
  expandModuleQualifiers,
  accordionId,
  setExpandModuleGlobally,
  expandModuleGlobally,
  expandedParent,
  expandedChild,
  setExpandedParent,
  setExpandedChild,
  currentModuleIdentifier, // New field to identify the module for which the claim belongs
}) => {
  const [expand, setExpand] = useState(false);
  const [nestedExpand, setNestedExpand] = useState([]);
  const [relatedClaimExpand, setRelatedClaimExpand] = useState(null);
  const [contextMenu, setContextmenu] = useState(false);
  const [contextMenuClaims, setContextMenuClaims] = useState(false);
  const [openFootnote, setOpenFootnote] = useState(false);
  const [currentFootnoteItem, setCurrentFootnoteItem] = useState(null);
  const [footnoteSymbols, setFootnoteSymbols] = useState({});
  const [currentFootnoteText, setcurrentFootnoteText] = useState("");
  const [usedSymbols, setusedSymbols] = useState([]);
  const [changeOccur, setchangeOccur] = useState(0);
  const [currentModuleIndex, setCurrentModuleIndex] = useState(null);
  const [currentSymbol, setcurrentSymbol] = useState(null);
  const [allSymbolsAssigned, setAllSymbolsAssigned] = useState(false);
  useEffect(() => {
    if (notUsedEditorToggle) {
      setExpand(undefined);
    }
  }, [length]);

  const handleMouseEnter = () => {
    setContextmenu(true);
  };

  const handleMouseLeave = () => {
    setContextmenu(false);
  };
  const handleMouseEnterClaims = () => {
    setContextMenuClaims(true);
  };

  const handleMouseLeaveClaims = () => {
    setContextMenuClaims(false);
  };

  // To track local storage change
  useEffect(() => {
    const handleChange = () => {
      setchangeOccur(Math.random());
    };

    window.addEventListener("symbolChange", handleChange);
    return () => window.removeEventListener("symbolChange", handleChange);
  }, []);
  //

  const handleCloseFootnoteModal = () => {
    setOpenFootnote(false);
    setcurrentSymbol("");
  };
  const handleSelectSymbol = (symbol) => {
    if (currentFootnoteItem) {
      const { item, subIndex } = currentFootnoteItem;
      const key = `${index}-${subIndex}`;
      setFootnoteSymbols({
        ...footnoteSymbols,
        [key]: symbol,
      });
    }
  };

  const [symbolChangeTick, setSymbolChangeTick] = useState(false);
  function readTextSymbolMap() {
    try {
      const stored = localStorage.getItem("allSymbols") || "[]";
      return new Map(JSON.parse(stored));
    } catch (e) {
      console.error(" allSymbols in localStorage", e);
      return new Map();
    }
  }
  const areAllFootnotesAssigned = (footnotes, textSymbolMap) => {
    if (!footnotes) return true;
    const parts = footnotes.split(/(?<=\.)\s*,\s*/g).filter(Boolean);
    return parts.every(
      (f) =>
        textSymbolMap.has(f.trim().endsWith(".") ? f.trim() : f.trim() + ".") &&
        textSymbolMap.get(
          f.trim().endsWith(".") ? f.trim() : f.trim() + ".",
        ) !== "Not Assigned",
    );
  };
  const [assignSymbol, setAssignSymbol] = useState({});

  const areAllFootnotesAssignedForModule = (module, textSymbolMap) => {
    if (module?.mlrStatus === "Expired" || module?.mustUse === false) {
      return true;
    }
    const mainAssigned = areAllFootnotesAssigned(
      module.footnotes,
      textSymbolMap,
    );
    const isComponent = !!module.componentId;

    const relatedAssigned =
      Array.isArray(module.relatedClaims) &&
      module.relatedClaims.every((rel) => {
        let relMatchAssigned = true;
        if (rel?.mlrStatus === "Expired") {
          return true;
        }
        const relFootnotesAssigned = areAllFootnotesAssigned(
          rel.footnotes,
          textSymbolMap,
        );
        if (!isComponent) {
          relMatchAssigned = areAllFootnotesAssigned(
            rel.matchText,
            textSymbolMap,
          );
        }
        return relFootnotesAssigned && relMatchAssigned;
      });
    return mainAssigned && relatedAssigned;
  };
  const areAllFootnotesAssignedForAParticularModule = () => {
    let assignSymbolObj = {};
    (modulesArray || []).forEach((module) => {
      const isComponent = !!module.componentId;
      if (module?.mlrStatus === "Expired") {
        assignSymbolObj[module.claimName || module.componentDocNumber] = true;
        return;
      }
      const mainAssigned = areAllFootnotesAssigned(
        module.footnotes,
        textSymbolMap,
      );

      const relatedAssigned =
        Array.isArray(module.relatedClaims) &&
        module.relatedClaims.every((rel) => {
          let relMatchAssigned = true;
          if (rel?.claimName === "CL-005012") {
          }
          if (rel?.mlrStatus === "Expired") {
            return true;
          }
          const relFootnotesAssigned = areAllFootnotesAssigned(
            rel.footnotes,
            textSymbolMap,
          );

          if (!isComponent) {
            relMatchAssigned = areAllFootnotesAssigned(
              rel.matchText,
              textSymbolMap,
            );
          }
          return relFootnotesAssigned && relMatchAssigned;
        });
      assignSymbolObj[module.claimName || module.componentDocNumber] =
        mainAssigned && relatedAssigned;
    });
    setAssignSymbol(assignSymbolObj);
  };
  useEffect(() => {
    try {
      const textSymbolMap = readTextSymbolMap();

      const allAssigned = (modulesArray || []).every((module) =>
        areAllFootnotesAssignedForModule(module, textSymbolMap),
      );
      areAllFootnotesAssignedForAParticularModule();
      setAllSymbolsAssigned(allAssigned);
    } catch (err) {
      console.error("Error checking assignments:", err);
      setAllSymbolsAssigned(false);
      setAssignSymbol({});
    }
  }, [symbolChangeTick, modulesArray, openQualifiersModal]);

  const storedSymbols = localStorage.getItem("allSymbols") || "[]";
  const [textSymblMapTemp, setTextSymblMapTemp] = useState(
    new Map(JSON.parse(storedSymbols)),
  );

  let textSymbolMap = new Map();

  if (storedSymbols) {
    try {
      const parsed = JSON.parse(storedSymbols);
      textSymbolMap = new Map(parsed);
    } catch (e) {
      console.error("Failed to parse storedSymbols from localStorage", e);
    }
  }

  function getSymbol(text) {
    return textSymbolMap?.get(text?.endsWith(".") ? text : text + ".");
  }
  const enableMatchText = droppedComponentIds?.includes(component.componentId);
  const isComponentDropped = !!enableMatchText;
  const isComponentNotdDropped = !isComponentDropped;
  const isComponentDraggable = component?.mlrStatus !== "Expired";
  const canUseRelatedSections = isComponentDropped && isComponentDraggable;
  const isClaimsDropped = claimsArray?.find(
    (claimId) => claimId === claim.claimId,
  );

  const rcDropCheck = (rcClaimId) => {
    return claimsArray?.some((claimId) => claimId === rcClaimId);
  };
  const isReusableTextDropped = reusableTextIdsArray?.find(
    (rtId) => rtId === reusableText?.reusableTextId,
  );

  const shouldHideTooltip = component?.relatedClaims.some(
    (item) => getSymbol(item.footnotes) !== "Not Assigned",
  );

  const getDraggableClass = (
    itemId,
    enableMatchText,
    droppedTextIds,
    itemFootnotes,
  ) => {
    const hasValidFootnote =
      itemFootnotes && getSymbol(itemFootnotes) !== "Not Assigned";

    if (enableMatchText && !droppedTextIds?.includes(itemId)) {
      if (itemFootnotes === undefined || hasValidFootnote) {
        return "d-flex draggableText";
      }
    }

    if (droppedTextIds?.includes(itemId)) {
      return "d-flex draggableText disabledmatchText";
    }

    return "d-flex draggableText protectedMatchText";
  };
  const isDraggableText = (item, enableMatchText, droppedTextIds) => {
    if (!enableMatchText || droppedTextIds?.includes(item.id)) {
      return false;
    }

    if (item.footnotes === undefined) {
      return true;
    }
    return getSymbol(item.footnotes) !== "Not Assigned";
  };

  const dragToCanvasMatchText = (e, claim, rc) => {
    let footnotesSymbols = [];
    let totalFootnotes = [];
    if (claim.footnotes) {
      claim.footnotes.split(/(?<=\.)\s*,\s*/g).map((note, i) => {
        footnotesSymbols.push(getSymbol(note.trim()) || "");
        totalFootnotes.push(
          `<sup>${getSymbol(note.trim()) || ""}</sup>` +
            (note.trim().endsWith(".") ? note.trim() : note.trim() + "."),
        );
      });
    }
    if (isReferenceFootnotes) {
      sendAtomDetails2Canvas({
        id: e.target.parentNode.id || e.target.id,
        type: "atomText",
        data: rc
          ? getSymbol(claim?.matchText) + "" + claim?.matchText
          : claim?.matchText,
        claimFootnotes: totalFootnotes,
        claimReferences: claim?.references,
        claimAbbreviation: claim?.abbreviation,
        claimId: claim?.claimId,
        footnoteSymbol: footnotesSymbols,
        rcClaimIds: !rc ? claim?.relatedClaims.map((rc) => rc.claimId) : [],
        rcclaimSymbls: !rc
          ? claim?.relatedClaims.map((rc) => getSymbol(rc.matchText))
          : [],
        matchTextSymbol: rc ? getSymbol(claim?.matchText) : "",
        moduleIdIdentifier: currentModuleIdentifier,
      });
    } else {
      sendAtomDetails2Canvas({
        id: e.target.parentNode.id || e.target.id,
        type: "atomText",
        data: rc
          ? getSymbol(claim?.matchText) + "" + claim?.matchText
          : claim?.matchText,
        claimId: claim.claimId,
        claimFootnotes: "",
        claimAbbreviation: "",
        claimReferences: [],
        footnoteSymbol: footnotesSymbols,
        rcClaimIds: !rc ? claim.relatedClaims.map((rc) => rc.claimId) : [],
        rcclaimSymbls: !rc
          ? claim.relatedClaims.map((rc) => getSymbol(rc.matchText))
          : [],
        matchTextSymbol: rc ? getSymbol(claim?.matchText) : "",
        moduleIdIdentifier: currentModuleIdentifier,
      });
    }
  };
  const dragToCanvasMatchTextVariant = (e, item, rc) => {
    let footnotesSymbols = [];
    let totalFootnotes = [];
    if (claim.footnotes) {
      claim.footnotes.split(/(?<=\.)\s*,\s*/g).map((note, i) => {
        footnotesSymbols.push(getSymbol(note.trim()) || "");
        totalFootnotes.push(
          `<sup>${getSymbol(note.trim()) || ""}</sup>` +
            (note.trim().endsWith(".") ? note.trim() : note.trim() + "."),
        );
      });
    }
    if (isReferenceFootnotes) {
      sendAtomDetails2Canvas({
        id: e.target.parentNode.id || e.target.id,
        type: "atomText",
        data: item.matchText,
        claimFootnotes: totalFootnotes,
        claimReferences: claim?.references,
        claimAbbreviation: claim?.abbreviation,
        claimId: claim?.claimId,
        footnoteSymbol: footnotesSymbols,
        rcClaimIds: !rc ? claim?.relatedClaims.map((rc) => rc.claimId) : [],
        rcclaimSymbls: !rc
          ? claim?.relatedClaims.map((rc) => getSymbol(rc.matchText))
          : [],
        matchTextSymbol: rc ? getSymbol(item?.matchText) : "",
        moduleIdIdentifier: currentModuleIdentifier,
      });
    } else {
      sendAtomDetails2Canvas({
        id: e.target.parentNode.id || e.target.id,
        type: "atomText",
        data: item.matchText,
        claimId: claim.claimId,
        claimFootnotes: "",
        claimAbbreviation: "",
        claimReferences: [],
        footnoteSymbol: footnotesSymbols,
        rcClaimIds: !rc ? claim.relatedClaims.map((rc) => rc.claimId) : [],
        rcclaimSymbls: !rc
          ? claim.relatedClaims.map((rc) => getSymbol(rc.matchText))
          : [],
        matchTextSymbol: rc ? getSymbol(item?.matchText) : "",
        moduleIdIdentifier: currentModuleIdentifier,
      });
    }
  };
  const handleQualifiersModal = () => {
    setOpenQualifiersModal(true);
  };
  const handleCloseQualifiersModal = (cancelClicked) => {
    if (cancelClicked) {
      localStorage.setItem(
        "allSymbols",
        JSON.stringify(Array.from(textSymblMapTemp.entries())),
      );
    }
    setOpenQualifiersModal(false);
  };

  const isClaim = claim && Object.keys(claim).length > 0;
  const isComponent = component && Object.keys(component).length > 0;
  const isRts = reusableText && Object.keys(reusableText).length > 0;

  const group = isClaim ? "claim" : isComponent ? "component" : "rts";
  const uniqueKey = `${group}-${accordionId}`;
  const expandMod = expandModuleGlobally === uniqueKey;
  useEffect(() => {
    if (isComponentNotdDropped) {
      setNestedExpand([]);
    }
    setRelatedClaimExpand(null);
  }, [isComponentNotdDropped, expandModuleGlobally]);

  useEffect(() => {
    if (expandedParent === claim?.claimName && claim?.mlrStatus === "Expired") {
      setExpandModuleGlobally(null);
    }
    if (
      expandedParent === component?.componentDocNumber &&
      component?.mlrStatus === "Expired"
    ) {
      setExpandModuleGlobally(null);
    }
    if (
      expandedParent === reusableText?.reusableTextName &&
      reusableText?.mlrStatus === "Expired"
    ) {
      setExpandModuleGlobally(null);
    }
    if (
      claim?.relatedClaims?.find((item) => item?.claimName === expandedChild)
        ?.mlrStatus === "Expired"
    ) {
      setNestedExpand(null);
    }
    if (
      component?.relatedReusableTexts?.find(
        (item) => item?.reusableTextName === expandedChild,
      )?.mlrStatus === "Expired"
    ) {
      setNestedExpand(null);
    }
    if (
      component?.relatedClaims?.find(
        (item) => item?.claimName === expandedChild,
      )?.mlrStatus === "Expired"
    ) {
      setNestedExpand(null);
    }
  }, [claim, component, reusableText]);

  return (
    <>
      <div className="moduleParentClaim">
        <div
          style={{ display: "flex", alignItems: "center" }}
          onClick={() => {
            if (claim?.mlrStatus === "Expired") {
              return;
            }
            if (component?.mlrStatus === "Expired") {
              return;
            }
            if (reusableText?.mlrStatus === "Expired") {
              return;
            }
            if (!accordionId) return;

            const isClaimGroup = isClaim !== undefined;
            const isComponentGroup = isComponent !== undefined;
            const isRtsGroup = isRts !== undefined;

            let shouldToggle = false;

            if (isClaimGroup || isComponentGroup) {
              if (component?.subType === "Image") {
                shouldToggle = true;
              } else if (
                assignSymbol[claim?.claimName || component?.componentDocNumber]
              ) {
                shouldToggle = true;
              }
            } else if (isRtsGroup) {
              shouldToggle = true;
            }

            if (shouldToggle) {
              setExpandModuleGlobally((prev) =>
                prev === uniqueKey ? null : uniqueKey,
              );
            }
            if (claim?.claimName) {
              setExpandedParent(claim?.claimName);
            }
            if (component?.componentDocNumber) {
              setExpandedParent(component?.componentDocNumber);
            }
            if (reusableText?.reusableTextName) {
              setExpandedParent(reusableText?.reusableTextName);
            }
          }}
        >
          <div
            className="expand-module"
            style={{
              backgroundColor: expandMod ? "#F0F5F8" : "",
              color: expandMod ? "#203662" : "",
              fontSize: expandMod ? "30px" : "20px",
              fontWeight: expandMod ? "100" : "",
            }}
          >
            {" "}
            {expandMod ? (
              <p className="minusIcon22">-</p>
            ) : (
              <p className="plusIcon22">+</p>
            )}{" "}
          </div>
          {claim && (
            <div className="boldText d-flex" style={{ marginLeft: "4px" }}>
              <Tooltip
                title={
                  claim?.mlrStatus !== "Expired"
                    ? "Available for use"
                    : "Expired"
                }
                arrow
                classes={{ popper: "toolTipClass2", tooltip: "toolTipClass2" }}
                placement="bottom-start"
              >
                <span>
                  <img
                    src={
                      claim?.mlrStatus !== "Expired" ? available : expiredStatus
                    }
                    className="img-fluid expiryIcon"
                    alt=""
                  />
                </span>
              </Tooltip>

              {claim.claimName}
            </div>
          )}
          {reusableText && (
            <div className="boldText d-flex" style={{ marginLeft: "4px" }}>
              <Tooltip
                title={
                  reusableText?.mlrStatus !== "Expired"
                    ? "Available for Use"
                    : "Expired"
                }
                arrow
                classes={{ popper: "toolTipClass2", tooltip: "toolTipClass2" }}
                placement="bottom-start"
              >
                <span>
                  <img
                    src={
                      reusableText?.mlrStatus !== "Expired"
                        ? available
                        : expiredStatus
                    }
                    className="img-fluid expiryIcon"
                    alt=""
                  />
                </span>
              </Tooltip>
              {reusableText.reusableTextName}
            </div>
          )}
          {component && (
            <div className="boldText " style={{ marginLeft: "4px" }}>
              <Tooltip
                title={
                  component?.mlrStatus !== "Expired"
                    ? "Available for use"
                    : "Expired"
                }
                arrow
                classes={{ popper: "toolTipClass2", tooltip: "toolTipClass2" }}
                placement="bottom-start"
              >
                <span>
                  <img
                    src={
                      component?.mlrStatus !== "Expired"
                        ? available
                        : expiredStatus
                    }
                    className="img-fluid expiryIcon"
                    alt=""
                  />
                </span>
              </Tooltip>
              {component.componentDocNumber}
            </div>
          )}
          {claim && (
            <>
              <div
                className="parentModulebox"
                style={{
                  backgroundColor: claim.mustUse ? "#E32B35" : "#378A05",
                  marginLeft: "10px",
                }}
              ></div>

              {claim?.mlrStatus === "Expired" ? (
                <Tooltip
                  title="Claim is expired, can't be used for authoring"
                  arrow
                  classes={{ popper: "toolTipClass", tooltip: "toolTipClass" }}
                  placement="bottom-start"
                >
                  <div className="expiredContent">
                    <span>Expired</span>
                  </div>
                </Tooltip>
              ) : !assignSymbol[claim?.claimName] ? (
                <div
                  className="assignSymbolsText"
                  onClick={() => {
                    setSelectedClaimIndex(index);
                    setSelectedRelatedClaimIndex({
                      module: null, //index,
                      sub: null,
                    });
                    setExpandModuleQualifiers((prev) =>
                      prev.map((expanded, i) =>
                        i === index ? !expanded : false,
                      ),
                    );
                    handleQualifiersModal();
                  }}
                >
                  <span>Assign Symbols</span>
                </div>
              ) : (
                <div className="assignSymbolsText">
                  <span></span>
                </div>
              )}
            </>
          )}
          {reusableText && (
            <>
              {" "}
              <div
                className="parentModulebox"
                style={{
                  backgroundColor: reusableText.mustUse ? "#E32B35" : "#378A05",
                  marginLeft: "10px",
                }}
              ></div>
              {reusableText?.mlrStatus === "Expired" && (
                <Tooltip
                  title="Reusable Text is expired, can't be used for authoring"
                  arrow
                  classes={{ popper: "toolTipClass", tooltip: "toolTipClass" }}
                  placement="bottom-start"
                >
                  <div className="expiredContent">
                    <span>Expired</span>
                  </div>
                </Tooltip>
              )}
            </>
          )}
          {component && (
            <>
              <div
                className="parentModulebox"
                style={{
                  backgroundColor: component.mustUse ? "#E32B35" : "#378A05",
                  marginLeft: "10px",
                }}
              ></div>
              {component?.mlrStatus === "Expired" ? (
                <Tooltip
                  title="Component is expired, can't be used for authoring"
                  arrow
                  classes={{ popper: "toolTipClass", tooltip: "toolTipClass" }}
                  placement="bottom-start"
                >
                  <div className="expiredContent">
                    <span>Expired</span>
                  </div>
                </Tooltip>
              ) : component.subType === "Data Graphic" &&
                !assignSymbol[component?.componentDocNumber] ? (
                <div
                  className="assignSymbolsText"
                  onClick={() => {
                    setSelectedClaimIndex(index);
                    setSelectedRelatedClaimIndex({
                      module: null,
                      sub: null,
                    });
                    setExpandModuleQualifiers((prev) =>
                      prev.map((expanded, i) =>
                        i === index ? !expanded : false,
                      ),
                    );
                    handleQualifiersModal();
                  }}
                >
                  <span>Assign Symbols</span>
                </div>
              ) : (
                <div className="assignSymbolsText">
                  <span></span>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {!expandMod && index !== modulesArray.length - 1 && (
        <div className="borderLine"></div>
      )}
      <div className="text-container pb-2">
        {claim && expandMod && (
          <>
            {" "}
            <div
              style={{ marginTop: "8px" }}
              className={
                claim?.footnotes
                  ? getSymbol(claim.footnotes) !== "Not Assigned"
                    ? `matchText${
                        isClaimsDropped || claim?.mlrStatus === "Expired"
                          ? " disabledmatchText"
                          : ""
                      }`
                    : "matchText disabledmatchText"
                  : isClaimsDropped || claim?.mlrStatus === "Expired"
                    ? "matchText disabledmatchText"
                    : "matchText"
              }
            >
              Match Text
              {claim?.footnotes ? (
                getSymbol(claim.footnotes) !== "Not Assigned" ? (
                  ""
                ) : (
                  <div
                    className="tooltipRC"
                    onMouseEnter={handleMouseEnterClaims}
                    onMouseLeave={handleMouseLeaveClaims}
                  >
                    <Tooltip
                      title={
                        "To drag & drop match text, begin by assigning a symbol to the footnote."
                      }
                      arrow={true}
                      classes={{ popper: "toolTipClass" }}
                      data-html="true"
                      placement="bottom-start"
                    >
                      <img
                        src={InfoIconWarning}
                        alt="warning"
                        style={{
                          width: "10px",
                          height: "10px",
                          display: "block",
                          marginTop: "3px",
                          marginLeft: "6px",
                        }}
                        className="warnImg"
                      />
                    </Tooltip>
                  </div>
                )
              ) : (
                ""
              )}
            </div>
            <div
              className={
                (
                  getSymbol(claim.footnotes) !== "Not Assigned"
                    ? isClaimsDropped || claim?.mlrStatus === "Expired"
                      ? false
                      : true
                    : false
                )
                  ? "d-flex draggableText"
                  : "d-flex notdraggableText"
              }
              style={{ marginTop: "0px" }}
              draggable={
                getSymbol(claim.footnotes) !== "Not Assigned"
                  ? isClaimsDropped || claim?.mlrStatus === "Expired"
                    ? false
                    : true
                  : false
              }
              onDragStart={(e) => dragToCanvasMatchText(e, claim)}
            >
              {!isClaimsDropped &&
              getSymbol(claim.footnotes) !== "Not Assigned" &&
              claim?.mlrStatus !== "Expired" ? (
                <img src={sixDotIcon} alt="" className="img-fluid sixdotIcon" />
              ) : (
                <img
                  src={sixDotIcon}
                  alt=""
                  className="img-fluid sixdotIcon disImage"
                />
              )}
              <div
                className={
                  getSymbol(claim.footnotes) !== "Not Assigned"
                    ? `textvariant  ${
                        isClaimsDropped || claim?.mlrStatus === "Expired"
                          ? "disabledmatchText"
                          : ""
                      }`
                    : `textvariant disabledmatchText`
                }
              >
                {claim.matchText}
              </div>
            </div>
            <>
              {claim.matchTextVariants?.map((item, index) => {
                return (
                  <>
                    <div
                      className={
                        claim?.footnotes
                          ? getSymbol(claim.footnotes) !== "Not Assigned"
                            ? `matchText ${
                                isClaimsDropped ||
                                claim?.mlrStatus === "Expired"
                                  ? "disabledmatchText"
                                  : ""
                              }`
                            : "matchText disabledmatchText"
                          : isClaimsDropped || claim?.mlrStatus === "Expired"
                            ? "disabledmatchText matchText"
                            : "matchText"
                      }
                    >
                      {`Match Text Variant ${index + 1}`}{" "}
                      {claim?.footnotes ? (
                        getSymbol(claim.footnotes) !== "Not Assigned" ? (
                          ""
                        ) : (
                          <div
                            className="tooltipRC"
                            onMouseEnter={handleMouseEnterClaims}
                            onMouseLeave={handleMouseLeaveClaims}
                          >
                            <Tooltip
                              title={
                                "To drag & drop match text, begin by assigning a symbol to the footnote."
                              }
                              arrow={true}
                              classes={{ popper: "toolTipClass" }}
                              data-html="true"
                              placement="bottom-start"
                            >
                              <img
                                src={InfoIconWarning}
                                alt="warning"
                                style={{
                                  width: "10px",
                                  height: "10px",
                                  display: "block",
                                  marginTop: "3px",
                                  marginLeft: "6px",
                                }}
                                className="warnImg"
                              />
                            </Tooltip>
                          </div>
                        )
                      ) : (
                        ""
                      )}
                    </div>
                    <div
                      className={
                        (
                          getSymbol(claim.footnotes) !== "Not Assigned"
                            ? isClaimsDropped || claim?.mlrStatus === "Expired"
                              ? false
                              : true
                            : false
                        )
                          ? "d-flex draggableText"
                          : "d-flex notdraggableText"
                      }
                      style={{ marginTop: "0px" }}
                      draggable={
                        getSymbol(claim.footnotes) !== "Not Assigned"
                          ? isClaimsDropped || claim?.mlrStatus === "Expired"
                            ? false
                            : true
                          : false
                      }
                      onDragStart={(e) => dragToCanvasMatchTextVariant(e, item)}
                    >
                      {!isClaimsDropped &&
                      getSymbol(claim.footnotes) !== "Not Assigned" ? (
                        <img
                          src={sixDotIcon}
                          alt=""
                          className="img-fluid sixdotIcon"
                        />
                      ) : (
                        <img
                          src={sixDotIcon}
                          alt=""
                          className="img-fluid sixdotIcon disImage"
                        />
                      )}

                      <div
                        className={
                          getSymbol(claim.footnotes) !== "Not Assigned"
                            ? `textvariant ${
                                isClaimsDropped ||
                                claim?.mlrStatus === "Expired"
                                  ? "disabledmatchText"
                                  : ""
                              }`
                            : `textvariant disableText `
                        }
                      >
                        {item.matchText}
                      </div>
                    </div>
                  </>
                );
              })}
            </>
            {claim.footnotes?.length > 0 &&
              claim.footnotes.split(/(?<=\.)\s*,\s*/g).map((note, i) => {
                return (
                  <div
                    key={i}
                    className={
                      getSymbol(claim.footnotes) !== "Not Assigned"
                        ? `${
                            isClaimsDropped || claim?.mlrStatus === "Expired"
                              ? "disabledmatchText"
                              : "matchText1"
                          }`
                        : `disabledmatchText  `
                    }
                  >
                    <div style={{ whiteSpace: "nowrap" }} className="topics">
                      Footnotes
                      {getSymbol(note.trim()) &&
                        getSymbol(note.trim()) !== "Not Assigned" && (
                          <>
                            <span
                              className="footnoteSymbol"
                              style={{
                                position: "relative",
                                left: "115px",
                                paddingTop:
                                  getSymbol(note.trim()) === "*"
                                    ? "3px"
                                    : "0px",
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {getSymbol(note.trim())}
                            </span>
                            {
                              <span
                                className="assignSymbolActive"
                                style={{
                                  // marginLeft: "122px",
                                  position: "relative",
                                  left: "115px",
                                  cursor: rcDropCheck(claim.claimId)
                                    ? "not-allowed"
                                    : "pointer",
                                  fontSize: "12px",
                                }}
                                onClick={(e) => {
                                  if (rcDropCheck(claim.claimId)) {
                                    return;
                                  }
                                  e.stopPropagation();
                                  setcurrentFootnoteText(note.trim());
                                  // setcurrentSymbol(getSymbol(note.trim()));
                                  setCurrentModuleIndex(index);
                                  setSelectedClaimIndex(index);
                                  setSelectedRelatedClaimIndex({
                                    module: null,
                                    sub: null,
                                  });
                                  setExpandModuleQualifiers((prev) =>
                                    prev.map((expanded, i) =>
                                      i === index ? !expanded : false,
                                    ),
                                  );
                                  setOpenQualifiersModal(true);
                                }}
                              >
                                Edit Symbol
                              </span>
                            }{" "}
                          </>
                        )}
                    </div>{" "}
                    <div className="paragraphText">
                      {" "}
                      {note.trim()}
                      {note.trim().endsWith(".") ? "" : "."}
                    </div>
                  </div>
                );
              })}
            {claim?.abbreviation?.length > 0 && (
              <div
                className={
                  getSymbol(claim.footnotes) !== "Not Assigned"
                    ? `${
                        isClaimsDropped || claim?.mlrStatus === "Expired"
                          ? "disabledmatchText"
                          : "matchText1"
                      }`
                    : `disabledmatchText  `
                }
              >
                Abbreviations
              </div>
            )}
            <div
              className={
                getSymbol(claim.footnotes) !== "Not Assigned"
                  ? `textvariant1  ${
                      isClaimsDropped || claim?.mlrStatus === "Expired"
                        ? "disabledmatchText"
                        : ""
                    }`
                  : `textvariant1 notdraggableText disabledmatchText  `
              }
            >
              {" "}
              {claim?.abbreviation
                ?.split(";")
                .filter((item) => item.trim() !== "")
                .map((item, index) => (
                  <div key={index}>{item.trim()}</div>
                ))}
            </div>
            {claim.references?.length > 0 && (
              <div
                className={
                  getSymbol(claim.footnotes) !== "Not Assigned"
                    ? `${
                        isClaimsDropped || claim?.mlrStatus === "Expired"
                          ? "disabledmatchText"
                          : "matchText1"
                      }`
                    : `disabledmatchText  `
                }
              >
                References
              </div>
            )}
            {claim.references?.map((item, index) => {
              return (
                <>
                  <div
                    className={
                      getSymbol(claim.footnotes) !== "Not Assigned"
                        ? `textvariant1  ${
                            isClaimsDropped || claim?.mlrStatus === "Expired"
                              ? "disabledmatchText"
                              : ""
                          }`
                        : `textvariant1 notdraggableText disabledmatchText  `
                    }
                  >
                    {" "}
                    {`${index + 1}. ${item.documentName}`}
                  </div>
                </>
              );
            })}
            {claim?.relatedClaims?.length > 0 && (
              <div className="related-section mt-2">
                <div
                  className="matchText collapsible-header "
                  onClick={(e) => {
                    e.stopPropagation();
                    setRelatedClaimExpand((prev) =>
                      prev === `claims-${index}` ? null : `claims-${index}`,
                    );
                    setNestedExpand([]);
                  }}
                >
                  {relatedClaimExpand === `claims-${index}` ? (
                    <span
                      className=" rcsAndrtsMinus expand-module"
                      style={{
                        position: "relative",
                        fontSize: "30px",
                        backgroundColor: "rgb(240, 245, 248)",
                        color: "rgb(2, 2, 2)",
                        fontWeight: 100,
                        paddingBottom: "2px",
                      }}
                    >
                      -
                    </span>
                  ) : (
                    <span className=" rcsAndrtsplus">+</span>
                  )}
                  <span className="boldText" style={{ marginLeft: "6px" }}>
                    Related Claims
                  </span>
                  <span
                    style={{
                      marginLeft: "8px",
                      fontSize: "12px",
                      color: "#555",
                    }}
                  >
                    (items {claim.relatedClaims.length})
                  </span>

                  <div
                    className="tooltipRC"
                    onMouseEnter={handleMouseEnterClaims}
                    onMouseLeave={handleMouseLeaveClaims}
                  >
                    {" "}
                  </div>

                  {contextMenuClaims && isClaimsDropped && (
                    <>
                      <div className=" showTooltipRt d-flex">
                        <p>
                          To use Related Claims, first drag and drop the
                          matchText to the editor, then assign a symbol to the
                          footnotes
                        </p>
                      </div>
                      <div
                        class="contextMenuarrowRC"
                        id="contextMenuarrowRC"
                      ></div>
                    </>
                  )}
                </div>

                {/* Show related claims if expanded */}
                {relatedClaimExpand === `claims-${index}` &&
                  claim?.relatedClaims.map((item, subIndex) => {
                    const nestedKey = `claims-${index}-${subIndex}`;
                    return (
                      <div key={subIndex} className="pl-3 mt-2">
                        <div
                          className="matchText collapsible-header"
                          onClick={(e) => {
                            if (item?.mlrStatus === "Expired") {
                              return;
                            }
                            e.stopPropagation();
                            setNestedExpand((prev) =>
                              prev === nestedKey ? null : nestedKey,
                            );
                            if (item?.claimName) {
                              setExpandedChild(item?.claimName);
                            }
                          }}
                        >
                          {nestedExpand === nestedKey ? (
                            <span
                              className=" rcsAndrtsMinus expand-module"
                              style={{
                                fontSize: "30px",
                                backgroundColor: "rgb(240, 245, 248)",
                                color: "rgb(2, 2, 2)",
                                fontWeight: 100,
                                paddingBottom: "2px",
                              }}
                            >
                              -
                            </span>
                          ) : (
                            <span className=" rcsAndrtsplus">+</span>
                          )}
                          {item && (
                            <>
                              <div
                                className="boldText d-flex"
                                style={{ marginLeft: "4px" }}
                              >
                                <Tooltip
                                  title={
                                    item?.mlrStatus !== "Expired"
                                      ? "Available for use"
                                      : "Expired"
                                  }
                                  arrow
                                  classes={{
                                    popper: "toolTipClass2",
                                    tooltip: "toolTipClass2",
                                  }}
                                  placement="bottom-start"
                                >
                                  <span>
                                    <img
                                      src={
                                        item?.mlrStatus !== "Expired"
                                          ? available
                                          : expiredStatus
                                      }
                                      className="img-fluid expiryIcon"
                                      alt=""
                                    />
                                  </span>
                                </Tooltip>

                                {item.claimName}
                              </div>
                              <div
                                className="parentModulebox"
                                style={{
                                  backgroundColor: claim?.mustUse
                                    ? "#E32B35"
                                    : "#378A05",
                                  marginLeft: "10px",
                                  marginTop: "2px",
                                }}
                              ></div>
                              {item?.mlrStatus === "Expired" && (
                                <Tooltip
                                  title="Related Claim is expired, can't be used for authoring"
                                  arrow
                                  classes={{
                                    popper: "toolTipClass",
                                    tooltip: "toolTipClass",
                                  }}
                                  placement="bottom-start"
                                >
                                  <div className="expiredContentnew">
                                    <span>Expired</span>
                                  </div>
                                </Tooltip>
                              )}
                            </>
                          )}
                          {getSymbol(item.matchText) &&
                            getSymbol(item.matchText) !== "Not Assigned" &&
                            item?.mlrStatus !== "Expired" && (
                              <div style={{ marginLeft: "-38px" }}>
                                <span
                                  className={`footnoteSymbol ${
                                    rcDropCheck(item.claimId)
                                      ? "disabledmatchText"
                                      : ""
                                  }`}
                                  style={{
                                    position: "relative",
                                    left: "87.5px",
                                    paddingTop:
                                      getSymbol(item.matchText) === "*"
                                        ? "3px"
                                        : "0px",
                                    fontWeight: "bold",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {getSymbol(item.matchText)}
                                </span>
                                {
                                  <span
                                    className={`assignSymbolActive ${
                                      rcDropCheck(item.claimId)
                                        ? "disabledmatchText"
                                        : ""
                                    }`}
                                    style={{
                                      position: "relative",
                                      left: "83px",
                                      cursor: rcDropCheck(item.claimId)
                                        ? "not-allowed"
                                        : "pointer",
                                      fontSize: "12px",
                                    }}
                                    onClick={(e) => {
                                      if (rcDropCheck(item.claimId)) {
                                        return;
                                      }
                                      e.stopPropagation();

                                      setcurrentFootnoteText(item.matchText);
                                      // setcurrentSymbol(
                                      //   getSymbol(item.matchText)
                                      // );
                                      setCurrentModuleIndex(subIndex);
                                      setSelectedClaimIndex(index);
                                      setSelectedRelatedClaimIndex({
                                        module: index,
                                        sub: subIndex,
                                      });
                                      setExpandModuleQualifiers((prev) =>
                                        prev.map((expanded, i) =>
                                          i === index ? !expanded : false,
                                        ),
                                      );
                                      setOpenQualifiersModal(true);
                                    }}
                                  >
                                    Edit Symbol
                                  </span>
                                }{" "}
                              </div>
                            )}
                        </div>
                        {nestedExpand === nestedKey && (
                          <div className="textvariant-group ml-3">
                            {item.matchText && (
                              <>
                                <div
                                  className={`${
                                    rcDropCheck(item.claimId) ||
                                    item?.mlrStatus === "Expired"
                                      ? "disabledmatchText disabledtxt"
                                      : "matchText1"
                                  }`}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    whiteSpace: "nowrap",
                                    paddingLeft: "22px", //"28px",
                                  }}
                                >
                                  Match Text
                                </div>
                                <></>
                                <div
                                  key={item.id}
                                  className={
                                    getSymbol(claim.footnotes) !==
                                    "Not Assigned"
                                      ? `textvariant  ${
                                          rcDropCheck(item.claimId) ||
                                          claim?.mlrStatus === "Expired"
                                            ? "disabledmatchText disableTextvar"
                                            : "d-flex draggableText"
                                        }`
                                      : `textvariant disabledmatchText`
                                  }
                                  style={{
                                    marginTop: "0px",
                                    paddingLeft: "16px",
                                  }}
                                  draggable={
                                    getSymbol(item.matchText) !== "Not Assigned"
                                      ? rcDropCheck(item.claimId) ||
                                        item?.mlrStatus === "Expired"
                                        ? false
                                        : true
                                      : false
                                  }
                                  onDragStart={(e) =>
                                    dragToCanvasMatchText(e, item, true)
                                  }
                                >
                                  {rcDropCheck(item.claimId) ||
                                  claim?.mlrStatus === "Expired" ? (
                                    <img
                                      src={sixDotIcon}
                                      alt=""
                                      className="img-fluid sixdotIcon disImage"
                                    />
                                  ) : (
                                    <img
                                      src={sixDotIcon}
                                      alt=""
                                      className="img-fluid sixdotIcon "
                                    />
                                  )}
                                  <div className="textvariant1">
                                    {item.matchText}
                                  </div>
                                </div>

                                {/* Match text variant for related claims */}
                                {Array.isArray(item.matchTextVariants) ? (
                                  item.matchTextVariants.map(
                                    (mtVariants, index) => {
                                      return (
                                        <>
                                          <div
                                            className={`${
                                              rcDropCheck(item.claimId) ||
                                              item?.mlrStatus === "Expired"
                                                ? "disabledmatchText disabledtxt"
                                                : "matchText1"
                                            }`}
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              whiteSpace: "nowrap",
                                              paddingLeft: "22px",
                                            }}
                                          >
                                            {`Match Text Variant ${index + 1}`}
                                          </div>
                                          <div
                                            key={item.id}
                                            className={
                                              getSymbol(claim.footnotes) !==
                                              "Not Assigned"
                                                ? `textvariant  ${
                                                    rcDropCheck(item.claimId) ||
                                                    claim?.mlrStatus ===
                                                      "Expired"
                                                      ? "disabledmatchText disableTextvar"
                                                      : "d-flex draggableText"
                                                  }`
                                                : `textvariant disabledmatchText`
                                            }
                                            style={{
                                              marginTop: "0px",
                                              paddingLeft: "16px",
                                            }}
                                            draggable={
                                              getSymbol(item.matchText) !==
                                              "Not Assigned"
                                                ? rcDropCheck(item.claimId) ||
                                                  item?.mlrStatus === "Expired"
                                                  ? false
                                                  : true
                                                : false
                                            }
                                            onDragStart={(e) =>
                                              dragToCanvasMatchText(
                                                e,
                                                item,
                                                true,
                                              )
                                            }
                                          >
                                            {rcDropCheck(item.claimId) ||
                                            claim?.mlrStatus === "Expired" ? (
                                              <img
                                                src={sixDotIcon}
                                                alt=""
                                                className="img-fluid sixdotIcon disImage"
                                              />
                                            ) : (
                                              <img
                                                src={sixDotIcon}
                                                alt=""
                                                className="img-fluid sixdotIcon "
                                              />
                                            )}
                                            <div className="textvariant1">
                                              {mtVariants.matchText}
                                            </div>
                                          </div>
                                        </>
                                      );
                                    },
                                  )
                                ) : (
                                  <></>
                                )}
                              </>
                            )}
                            {item?.footnotes?.length > 0 &&
                              item.footnotes
                                .split(/(?<=\.)\s*,\s*/g)
                                .map((note, i) => {
                                  return (
                                    <div
                                      key={i}
                                      className={
                                        getSymbol(note.trim()) !==
                                        "Not Assigned"
                                          ? `${
                                              rcDropCheck(item.claimId) ||
                                              item?.mlrStatus === "Expired"
                                                ? "disabledmatchText"
                                                : "matchText1"
                                            }`
                                          : `disabledmatchText  `
                                      }
                                    >
                                      <div
                                        style={{ whiteSpace: "nowrap" }}
                                        className="matchText1"
                                      >
                                        Footnotes
                                        {getSymbol(note.trim()) &&
                                          getSymbol(note.trim()) !==
                                            "Not Assigned" && (
                                            <>
                                              <span
                                                className="footnoteSymbol"
                                                style={{
                                                  position: "relative",
                                                  left: "115.5px",
                                                  paddingTop:
                                                    getSymbol(note.trim()) ===
                                                    "*"
                                                      ? "3px"
                                                      : "0px",

                                                  //top: "3px",
                                                  fontWeight: "bold",
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                {getSymbol(note.trim())}
                                              </span>
                                              {
                                                <span
                                                  className="assignSymbolActive"
                                                  style={{
                                                    position: "relative",
                                                    left: "109px",
                                                    cursor: "pointer",
                                                    fontSize: "12px",
                                                    pointerEvents: rcDropCheck(
                                                      item.claimId,
                                                    )
                                                      ? "none"
                                                      : "auto",
                                                  }}
                                                  onClick={(e) => {
                                                    e.stopPropagation();

                                                    setcurrentFootnoteText(
                                                      note.trim(),
                                                    );
                                                    // setcurrentSymbol(
                                                    //   getSymbol(note.trim())
                                                    // );
                                                    setCurrentModuleIndex(
                                                      subIndex,
                                                    );
                                                    setSelectedClaimIndex(
                                                      index,
                                                    );
                                                    setSelectedRelatedClaimIndex(
                                                      {
                                                        module: index,
                                                        sub: subIndex,
                                                      },
                                                    );
                                                    setExpandModuleQualifiers(
                                                      (prev) =>
                                                        prev.map(
                                                          (expanded, i) =>
                                                            i === index
                                                              ? !expanded
                                                              : false,
                                                        ),
                                                    );
                                                    setOpenQualifiersModal(
                                                      true,
                                                    );
                                                  }}
                                                >
                                                  Edit Symbol
                                                </span>
                                              }{" "}
                                            </>
                                          )}
                                      </div>{" "}
                                      <div className="paragraphText">
                                        {note.trim()}
                                        {note.trim().endsWith(".") ? "" : "."}
                                      </div>
                                    </div>
                                  );
                                })}
                            {item?.abbreviation?.length > 0 && (
                              <>
                                <div
                                  className={`${
                                    rcDropCheck(item.claimId) ||
                                    item?.mlrStatus === "Expired"
                                      ? "disabledmatchText"
                                      : "matchText1"
                                  }`}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  Abbreviations
                                </div>
                                <div
                                  className={`noborderFootnote ${getDraggableClass(
                                    item.id,
                                    enableMatchText,
                                    droppedTextIds,
                                    item.footnotes,
                                  )}`}
                                  //draggable={true}
                                  onDragStart={(e) =>
                                    sendAtomDetails2Canvas({
                                      id: e.target.parentNode.id || e.target.id,
                                      type: "atomText",
                                      data: item.abbreviation,
                                      claimId: claim.claimId,
                                      moduleIdIdentifier:
                                        currentModuleIdentifier,
                                    })
                                  }
                                >
                                  <div
                                    className={`${
                                      rcDropCheck(item.claimId) ||
                                      item?.mlrStatus === "Expired"
                                        ? "disabledmatchText"
                                        : "textvariant2"
                                    }`}
                                    style={{ paddingLeft: "6px" }}
                                  >
                                    {item?.abbreviation
                                      ?.split(";")
                                      .filter((item1) => item1.trim() !== "")
                                      .map((item1, index) => (
                                        <div key={index}>{item1.trim()}</div>
                                      ))}
                                  </div>
                                </div>
                                {/* ))} */}
                              </>
                            )}
                            {item.references?.length > 0 && (
                              <>
                                <div
                                  className={`${
                                    rcDropCheck(item.claimId) ||
                                    item?.mlrStatus === "Expired"
                                      ? "disabledmatchText"
                                      : "matchText1"
                                  }`}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  References
                                </div>
                                {item.references.map((ref, refIndex) => (
                                  <div
                                    key={refIndex}
                                    className={`noborderFootnote ${getDraggableClass(
                                      item.id,
                                      enableMatchText,
                                      droppedTextIds,
                                      item.footnotes,
                                    )}`}
                                    //draggable={true}
                                    onDragStart={(e) =>
                                      sendAtomDetails2Canvas({
                                        id:
                                          e.target.parentNode.id || e.target.id,
                                        type: "atomText",
                                        data: `${refIndex + 1}. ${
                                          ref.documentName
                                        }`,
                                        claimId: claim.claimId,
                                        moduleIdIdentifier:
                                          currentModuleIdentifier,
                                      })
                                    }
                                  >
                                    <div
                                      className={`${
                                        rcDropCheck(item.claimId) ||
                                        item?.mlrStatus === "Expired"
                                          ? "disabledmatchText"
                                          : "textvariant2"
                                      }`}
                                    >
                                      {`${refIndex + 1}. ${ref.documentName}`}
                                    </div>
                                  </div>
                                ))}
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            )}
            {index !== modulesArray.length - 1 && (
              <div className="borderLine"></div>
            )}
          </>
        )}
        {reusableText && expandMod && (
          <>
            {" "}
            <div
              style={{ marginTop: "8px", marginBottom: "8px" }}
              className={
                isReusableTextDropped || reusableText?.mlrStatus === "Expired"
                  ? "disabledmatchText matchText"
                  : "matchText"
              }
            >
              Match Text
            </div>
            <div
              className={
                isReusableTextDropped || reusableText?.mlrStatus === "Expired"
                  ? "d-flex draggableText disabledmatchText"
                  : "d-flex draggableText"
              }
              draggable={
                isReusableTextDropped || reusableText?.mlrStatus === "Expired"
                  ? false
                  : true
              }
              onDragStart={(e) =>
                sendAtomDetails2Canvas({
                  id: e.target.parentNode.id || e.target.id,
                  type: "atomText",
                  data: reusableText.matchText,
                  reusableTextId: reusableText.reusableTextId,
                  moduleIdIdentifier: currentModuleIdentifier,
                })
              }
            >
              {!isReusableTextDropped &&
                reusableText?.mlrStatus !== "Expired" && (
                  <img
                    src={sixDotIconGrayedOut}
                    alt=""
                    className="img-fluid sixdotIcon"
                  />
                )}
              <div
                style={{
                  marginLeft: `${
                    isReusableTextDropped ||
                    reusableText?.mlrStatus === "Expired"
                      ? "16px"
                      : ""
                  }`,
                }}
              >
                {reusableText.matchText}
              </div>
            </div>
            {reusableText.matchTextVariants.map((mtVariants, index) => {
              return (
                <>
                  <div
                    style={{ marginTop: "8px", marginBottom: "8px" }}
                    className={
                      isReusableTextDropped ||
                      reusableText?.mlrStatus === "Expired"
                        ? "disabledmatchText matchText"
                        : "matchText"
                    }
                  >
                    {`Match Text Variant ${index + 1}`}
                  </div>
                  <div
                    className={
                      isReusableTextDropped ||
                      reusableText?.mlrStatus === "Expired"
                        ? "d-flex draggableText disabledmatchText"
                        : "d-flex draggableText"
                    }
                    draggable={
                      isReusableTextDropped ||
                      reusableText?.mlrStatus === "Expired"
                        ? false
                        : true
                    }
                    onDragStart={(e) =>
                      sendAtomDetails2Canvas({
                        id: e.target.parentNode.id || e.target.id,
                        type: "atomText",
                        data: mtVariants.matchText,
                        reusableTextId: reusableText.reusableTextId,
                        moduleIdIdentifier: currentModuleIdentifier,
                      })
                    }
                  >
                    {!isReusableTextDropped &&
                      reusableText?.mlrStatus !== "Expired" && (
                        <img
                          src={sixDotIconGrayedOut}
                          alt=""
                          className="img-fluid sixdotIcon"
                        />
                      )}
                    <div
                      style={{
                        marginLeft: `${
                          isReusableTextDropped ||
                          reusableText?.mlrStatus === "Expired"
                            ? "16px"
                            : ""
                        }`,
                      }}
                      className="textvariant"
                    >
                      {mtVariants.matchText}
                    </div>
                  </div>
                  {index !== modulesArray.length - 1 && (
                    <div className="borderLine"></div>
                  )}
                </>
              );
            })}
          </>
        )}
        {component && expandMod && (
          <>
            {component.subType === "Image" && (
              <>
                {component.componentUrl && (
                  <>
                    <BulletPointTitle title="Image" />
                    <div
                      className={
                        isComponentDraggable
                          ? "d-flex draggableText"
                          : "d-flex notdraggableText disabledmatchText protectedMatchText"
                      }
                      id={component.componentId}
                      draggable={isComponentDraggable}
                      onDragStart={(e) =>
                        isComponentDraggable &&
                        sendAtomDetails2Canvas({
                          type: "Image",
                          // id: e.currentTarget.id,
                          id: `${component.componentId}-image`,
                          subType: "Image", //"Data graphic",
                          data: component?.componentUrl,
                          componentId: component.componentId,
                          moduleIdIdentifier: currentModuleIdentifier,
                        })
                      }
                    >
                      {isComponentDraggable ? (
                        <img
                          src={sixDotIcon}
                          alt=""
                          className="img-fluid sixdotIcon"
                        />
                      ) : (
                        <img
                          src={sixDotIcon}
                          alt=""
                          className="img-fluid sixdotIcon disImage"
                        />
                      )}
                      <div className="textvariant">
                        <img
                          src={component?.componentUrl}
                          alt=""
                          className="img-fluid sixdotIcon"
                          style={{
                            width: "85px",
                            cursor: "move",
                            padding: "5px",
                            backgroundColor: "rgb(255, 255, 255)",
                            boxShadow: "none",
                            border: "1px solid grey",
                          }}
                        />
                      </div>
                    </div>
                  </>
                )}
                {component?.title && (
                  <>
                    <BulletPointTitle
                      title="Title"
                      className={
                        droppedTitleIds.includes(component.componentId)
                          ? "matchText disabledmatchText"
                          : "matchText"
                      }
                    />
                    <div
                      className={
                        droppedTitleIds.includes(component.componentId) ||
                        component?.mlrStatus === "Expired"
                          ? "d-flex notdraggableText disabledmatchText protectedMatchText"
                          : "d-flex draggableText"
                      }
                      draggable={
                        !droppedTitleIds.includes(component.componentId) ||
                        isComponentDraggable
                      }
                      onDragStart={(e) => {
                        if (
                          !droppedTitleIds.includes(component.componentId) ||
                          isComponentDraggable
                        ) {
                          sendAtomDetails2Canvas({
                            id: component.componentId + "-title",
                            type: "atomText",
                            data: component?.title,
                            titleId: component.componentId,
                            moduleIdIdentifier: currentModuleIdentifier,
                          });
                        }
                      }}
                    >
                      {!droppedTitleIds.includes(component.componentId) &&
                      isComponentDraggable ? (
                        <img
                          src={sixDotIcon}
                          alt=""
                          className="img-fluid sixdotIcon"
                        />
                      ) : (
                        <img
                          src={sixDotIcon}
                          alt=""
                          className="img-fluid sixdotIcon disImage"
                        />
                      )}
                      <div
                        className={
                          droppedTitleIds.includes(component.componentId) ||
                          component?.mlrStatus === "Expired"
                            ? "textvariant disabledmatchText protectedMatchText"
                            : "textvariant"
                        }
                      >
                        {component.title}
                      </div>
                    </div>
                  </>
                )}
              </>
            )}

            {component.subType === "Data Graphic" && (
              <>
                {component.componentUrl && (
                  <>
                    <BulletPointTitle title="Data Graphic" />
                    <div
                      id={component.componentId}
                      className={
                        isComponentNotdDropped && isComponentDraggable
                          ? "d-flex draggableText"
                          : "d-flex notdraggableText disabledmatchText protectedMatchText"
                      }
                      draggable={isComponentNotdDropped && isComponentDraggable}
                      onDragStart={(e) => {
                        isComponentDraggable &&
                          isComponentNotdDropped &&
                          sendAtomDetails2Canvas({
                            //id: e.currentTarget.id,
                            id: `${component.componentId}-datagraphic`,
                            type: "Image",
                            data: component?.componentUrl,
                            subType: "Data graphic",
                            componentId: component.componentId,
                            moduleIdIdentifier: currentModuleIdentifier,
                          });
                      }}
                      style={{
                        opacity:
                          isComponentNotdDropped && isComponentDraggable
                            ? 1
                            : 0.7,
                        cursor:
                          isComponentNotdDropped && isComponentDraggable
                            ? "default"
                            : "not-allowed",
                      }}
                    >
                      {isComponentNotdDropped && isComponentDraggable ? (
                        <img
                          src={sixDotIcon}
                          alt=""
                          className="img-fluid sixdotIcon"
                        />
                      ) : (
                        <img
                          src={sixDotIcon}
                          alt=""
                          className="img-fluid sixdotIcon disImage"
                        />
                      )}
                      <div className="textvariant">
                        <img
                          draggable={
                            isComponentNotdDropped && isComponentDraggable
                          }
                          src={component?.componentUrl}
                          alt=""
                          className="img-fluid sixdotIcon"
                          style={{
                            width: "85px",
                            cursor: "move",
                            padding: "5px",
                            backgroundColor: "rgb(255, 255, 255)",
                            boxShadow: "none",
                            border: "1px solid grey",
                            cursor:
                              !isComponentNotdDropped ||
                              component?.mlrStatus === "Expired"
                                ? "not-allowed"
                                : "move",
                          }}
                        />
                      </div>
                    </div>
                  </>
                )}
                {component?.title && (
                  <>
                    <BulletPointTitle
                      title="Title"
                      className={
                        droppedTitleIds.includes(component.componentId) ||
                        component?.mlrStatus === "Expired"
                          ? "matchText disabledmatchText"
                          : "matchText"
                      }
                    />
                    <div
                      className={
                        droppedTitleIds.includes(component.componentId) ||
                        component?.mlrStatus === "Expired"
                          ? "d-flex notdraggableText"
                          : "d-flex draggableText"
                      }
                      draggable={
                        !droppedTitleIds.includes(component.componentId) ||
                        isComponentDraggable
                      }
                      onDragStart={(e) => {
                        if (
                          !droppedTitleIds.includes(component.componentId) ||
                          isComponentDraggable
                        ) {
                          sendAtomDetails2Canvas({
                            id: component.componentId + "-title",
                            type: "atomText",
                            data: component?.title,
                            titleId: component.componentId,
                            moduleIdIdentifier: currentModuleIdentifier,
                          });
                        }
                      }}
                    >
                      {!droppedTitleIds.includes(component.componentId) &&
                      isComponentDraggable ? (
                        <img
                          src={sixDotIcon}
                          alt=""
                          className="img-fluid sixdotIcon"
                        />
                      ) : (
                        <img
                          src={sixDotIcon}
                          alt=""
                          className="img-fluid sixdotIcon disImage"
                        />
                      )}
                      <div
                        className={
                          droppedTitleIds.includes(component.componentId) ||
                          component?.mlrStatus === "Expired"
                            ? "textvariant disabledmatchText"
                            : "textvariant"
                        }
                      >
                        {component.title}
                      </div>
                    </div>
                  </>
                )}

                {/* Related Claims Section */}
                {component?.relatedClaims?.length > 0 && (
                  <div className="related-section mt-2">
                    <div
                      className={`matchText collapsible-header ${
                        !canUseRelatedSections ? "disabledRelatedSection" : ""
                      }`}
                      style={{
                        opacity: canUseRelatedSections ? 1 : 0.4,
                        pointerEvents: canUseRelatedSections ? "auto" : "none",
                        cursor: canUseRelatedSections
                          ? "pointer"
                          : "not-allowed",
                      }}
                      onClick={(e) => {
                        if (!canUseRelatedSections) return;
                        e.stopPropagation();
                        setRelatedClaimExpand((prev) =>
                          prev === `components-${index}`
                            ? null
                            : `components-${index}`,
                        );
                        setNestedExpand([]);
                      }}
                    >
                      {relatedClaimExpand === `components-${index}` ? (
                        <span
                          className=" rcsAndrtsMinus expand-module"
                          style={{
                            // fontSize: "23px",
                            paddingBottom: "3px",
                            position: "relative",
                            top: "0px !important",
                            fontSize: "30px",
                            backgroundColor: "rgb(240, 245, 248)",
                            color: "rgb(2, 2, 2)",
                            fontWeight: 100,
                          }}
                        >
                          -
                        </span>
                      ) : (
                        <span className=" rcsAndrtsplus">+</span>
                      )}
                      <span className="boldText" style={{ marginLeft: "6px" }}>
                        Related Claims
                      </span>
                      <span
                        style={{
                          marginLeft: "8px",
                          fontSize: "12px",
                          color: "#555",
                        }}
                      >
                        (items {component.relatedClaims.length})
                      </span>

                      <div
                        className="tooltipRC"
                        onMouseEnter={handleMouseEnterClaims}
                        onMouseLeave={handleMouseLeaveClaims}
                      >
                        {" "}
                        {(!shouldHideTooltip || !enableMatchText) &&
                          isComponentNotdDropped && (
                            <img
                              src={moduleWarning}
                              alt="warning"
                              style={{
                                width: "10px",
                                height: "10px",
                                display: "block",
                                marginTop: "4px",
                                marginLeft: "10px",
                              }}
                              className="warnImg"
                            />
                          )}
                      </div>

                      {contextMenuClaims && isComponentNotdDropped && (
                        <>
                          <div className=" showTooltipRt d-flex">
                            <p>
                              To use Related Claims, first drag and drop the
                              image to the editor.
                            </p>
                          </div>
                          <div
                            class="contextMenuarrowRC"
                            id="contextMenuarrowRC"
                          ></div>
                        </>
                      )}
                    </div>

                    {/* Show related claims if expanded */}
                    {relatedClaimExpand === `components-${index}` &&
                      component.relatedClaims.map((item, subIndex) => {
                        const nestedKey = `claims-${index}-${subIndex}`;
                        const footnoteKey = `${index}-${subIndex}`;
                        return (
                          <div key={subIndex} className="pl-3 mt-2">
                            <div
                              className="matchText collapsible-header"
                              style={{
                                opacity: isComponentNotdDropped ? "0.7" : "1",
                              }}
                              onClick={(e) => {
                                if (item?.mlrStatus === "Expired") {
                                  return;
                                }
                                if (!isComponentNotdDropped) {
                                  e.stopPropagation();
                                  setNestedExpand((prev) =>
                                    prev === nestedKey ? null : nestedKey,
                                  );
                                  if (item?.claimName) {
                                    setExpandedChild(item?.claimName);
                                  }
                                }
                              }}
                            >
                              {nestedExpand === nestedKey ? (
                                <span
                                  className=" rcsAndrtsMinus expand-module"
                                  style={{
                                    fontSize: "30px",
                                    backgroundColor: "rgb(240, 245, 248)",
                                    color: "rgb(2, 2, 2)",
                                    fontWeight: 100,
                                    paddingBottom: "2px",
                                  }}
                                >
                                  -
                                </span>
                              ) : (
                                <span className=" rcsAndrtsplus">+</span>
                              )}
                              {item && (
                                <>
                                  <div
                                    className="boldText d-flex"
                                    style={{ marginLeft: "4px" }}
                                  >
                                    <Tooltip
                                      title={
                                        item?.mlrStatus !== "Expired"
                                          ? "Available for use"
                                          : "Expired"
                                      }
                                      arrow
                                      classes={{
                                        popper: "toolTipClass2",
                                        tooltip: "toolTipClass2",
                                      }}
                                      placement="bottom-start"
                                    >
                                      <span>
                                        <img
                                          src={
                                            item?.mlrStatus !== "Expired"
                                              ? available
                                              : expiredStatus
                                          }
                                          className="img-fluid expiryIcon"
                                          alt=""
                                        />
                                      </span>
                                    </Tooltip>

                                    {item.claimName}
                                  </div>
                                  <div
                                    className="parentModulebox"
                                    style={{
                                      backgroundColor: component?.mustUse
                                        ? "#E32B35"
                                        : "#378A05",
                                      marginLeft: "10px",
                                      marginTop: "2px",
                                    }}
                                  ></div>
                                  {item?.mlrStatus === "Expired" && (
                                    <Tooltip
                                      title="Related Claim is expired, can't be used for authoring"
                                      arrow
                                      classes={{
                                        popper: "toolTipClass",
                                        tooltip: "toolTipClass",
                                      }}
                                      placement="bottom-start"
                                    >
                                      <div className="expiredContentnew">
                                        <span>Expired</span>
                                      </div>
                                    </Tooltip>
                                  )}
                                </>
                              )}
                              {getSymbol(item.matchText) &&
                                getSymbol(item.matchText) !==
                                  "Not Assigned" && (
                                  <div style={{ marginLeft: "-38px" }}>
                                    {/* <span
                                      className="footnoteSymbol"
                                      style={{
                                        position: "relative",
                                        left: "90.5px",
                                        paddingTop:
                                          getSymbol(item.matchText) === "*"
                                            ? "3px"
                                            : "0px",
                                        fontWeight: "bold",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {getSymbol(item.matchText)}
                                    </span> */}
                                    {/* {
                                      <span
                                        className="assignSymbolActive"
                                        style={{
                                          position: "relative",
                                          left: "84.5px",
                                          cursor: "pointer",
                                          fontSize: "12px",
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setcurrentFootnoteText(
                                            item.matchText
                                          );
                                          // setcurrentSymbol(
                                          //   getSymbol(item.matchText)
                                          // );
                                          setCurrentModuleIndex(index);
                                          setSelectedClaimIndex(index);
                                          setSelectedRelatedClaimIndex({
                                            module: index,
                                            sub: subIndex,
                                          });
                                          setExpandModuleQualifiers((prev) =>
                                            prev.map((expanded, i) =>
                                              i === index ? !expanded : false
                                            )
                                          );
                                          setOpenQualifiersModal(true);
                                        }}
                                      >
                                        Edit Symbol
                                      </span>
                                    }{" "} */}
                                  </div>
                                )}
                            </div>
                            {nestedExpand === nestedKey && (
                              <div className="textvariant-group ml-3">
                                {item.matchText && (
                                  <>
                                    <div
                                      className={`matchText1 ${getDraggableClass(
                                        item.id,
                                        enableMatchText,
                                        droppedTextIds,
                                        item.footnotes,
                                      )}`}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        whiteSpace: "nowrap",
                                        paddingLeft: "34px",
                                        marginTop: "2px",
                                      }}
                                    >
                                      Match Text
                                    </div>
                                    <div
                                      key={item.id}
                                      className={getDraggableClass(
                                        item.id,
                                        enableMatchText,
                                        droppedTextIds,
                                        item.footnotes,
                                      )}
                                      draggable={isDraggableText(
                                        item,
                                        enableMatchText,
                                        droppedTextIds,
                                      )}
                                      style={{ marginLeft: "2px" }}
                                      onDragStart={(e) => {
                                        if (
                                          isDraggableText(
                                            item,
                                            enableMatchText,
                                            droppedTextIds,
                                          )
                                        ) {
                                          let footnotesSymbols = [];
                                          let totalFootnotes = [];
                                          if (item.footnotes) {
                                            item.footnotes
                                              .split(/(?<=\.)\s*,\s*/g)
                                              .map((note, i) => {
                                                footnotesSymbols.push(
                                                  getSymbol(note.trim()),
                                                );
                                                totalFootnotes.push(
                                                  `<sup>${getSymbol(
                                                    note.trim(),
                                                  )}</sup>` + note.trim(),
                                                );
                                              });
                                          }
                                          if (isReferenceFootnotes) {
                                            sendAtomDetails2Canvas({
                                              id: item.id,
                                              type: "atomText",
                                              data: item.matchText,
                                              subType: "DataGraphicText",
                                              matchTextId: item.id,
                                              componentId:
                                                component.componentId,
                                              claimAbbreviation:
                                                item.abbreviation,
                                              claimFootnotes: totalFootnotes,
                                              claimReferences: item.references,
                                              footnoteSymbol: footnotesSymbols,
                                              moduleIdIdentifier:
                                                currentModuleIdentifier,
                                            });
                                          } else {
                                            sendAtomDetails2Canvas({
                                              id: item.id,
                                              type: "atomText",
                                              data: item.matchText,
                                              subType: "DataGraphicText",
                                              matchTextId: item.id,
                                              componentId:
                                                component.componentId,
                                              claimAbbreviation: "",
                                              claimFootnotes: "",
                                              claimReferences: "",
                                              footnoteSymbol: footnotesSymbols,
                                              moduleIdIdentifier:
                                                currentModuleIdentifier,
                                            });
                                          }
                                        }
                                      }}
                                    >
                                      {isDraggableText(
                                        item,
                                        enableMatchText,
                                        droppedTextIds,
                                      ) ? (
                                        <img
                                          src={sixDotIcon}
                                          alt=""
                                          className="img-fluid sixdotIcon"
                                        />
                                      ) : (
                                        <img
                                          src={sixDotIcon}
                                          alt=""
                                          className="img-fluid sixdotIcon disImage"
                                        />
                                      )}
                                      <div className="textvariant1">
                                        {item.matchText}
                                      </div>
                                    </div>
                                    {Array.isArray(item.matchTextVariants) ? (
                                      item.matchTextVariants.map(
                                        (mtVariants, index) => {
                                          return (
                                            <>
                                              <div
                                                style={{
                                                  marginTop: "2px",
                                                  marginLeft: "24px",
                                                }}
                                                className={`matchText1 ${getDraggableClass(
                                                  item.id,
                                                  enableMatchText,
                                                  droppedTextIds,
                                                  item.footnotes,
                                                )}`}
                                              >
                                                {`Match Text Variant ${
                                                  index + 1
                                                }`}
                                              </div>
                                              <div
                                                style={{ marginLeft: "8px" }}
                                                className={`${getDraggableClass(
                                                  item.id,
                                                  enableMatchText,
                                                  droppedTextIds,
                                                  item.footnotes,
                                                )}`}
                                                draggable={
                                                  enableMatchText &&
                                                  !droppedTextIds?.includes(
                                                    item.id,
                                                  )
                                                }
                                                onDragStart={(e) => {
                                                  if (
                                                    isDraggableText(
                                                      item,
                                                      enableMatchText,
                                                      droppedTextIds,
                                                    )
                                                  ) {
                                                    let footnotesSymbols = [];
                                                    let totalFootnotes = [];
                                                    if (item.footnotes) {
                                                      item.footnotes
                                                        .split(
                                                          /(?<=\.)\s*,\s*/g,
                                                        )
                                                        .map((note, i) => {
                                                          footnotesSymbols.push(
                                                            getSymbol(
                                                              note.trim(),
                                                            ),
                                                          );
                                                          totalFootnotes.push(
                                                            `<sup>${getSymbol(
                                                              note.trim(),
                                                            )}</sup>` +
                                                              note.trim(),
                                                          );
                                                        });
                                                    }
                                                    if (isReferenceFootnotes) {
                                                      sendAtomDetails2Canvas({
                                                        id: item.id,
                                                        type: "atomText",
                                                        data: mtVariants.matchText,
                                                        subType:
                                                          "DataGraphicText",
                                                        matchTextId: item.id,
                                                        componentId:
                                                          component.componentId,
                                                        claimAbbreviation:
                                                          item.abbreviation,
                                                        claimFootnotes:
                                                          totalFootnotes,
                                                        claimReferences:
                                                          item.references,
                                                        footnoteSymbol:
                                                          footnotesSymbols,
                                                        moduleIdIdentifier:
                                                          currentModuleIdentifier,
                                                      });
                                                    } else {
                                                      sendAtomDetails2Canvas({
                                                        id: item.id,
                                                        type: "atomText",
                                                        data: mtVariants.matchText,
                                                        subType:
                                                          "DataGraphicText",
                                                        matchTextId: item.id,
                                                        componentId:
                                                          component.componentId,
                                                        claimAbbreviation: "",
                                                        claimFootnotes: "",
                                                        claimReferences: "",
                                                        footnoteSymbol:
                                                          footnotesSymbols,
                                                        moduleIdIdentifier:
                                                          currentModuleIdentifier,
                                                      });
                                                    }
                                                  }
                                                }}
                                              >
                                                {enableMatchText &&
                                                !droppedTextIds?.includes(
                                                  item.id,
                                                ) ? (
                                                  <img
                                                    src={sixDotIcon}
                                                    alt=""
                                                    className="img-fluid sixdotIcon"
                                                  />
                                                ) : (
                                                  <img
                                                    src={sixDotIconGrayedOut}
                                                    alt=""
                                                    className="img-fluid sixdotIcon disImage"
                                                  />
                                                )}
                                                <div className="textvariant2">
                                                  {mtVariants.matchText}
                                                </div>
                                              </div>
                                            </>
                                          );
                                        },
                                      )
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                )}
                                {item?.footnotes?.length > 0 &&
                                  item.footnotes
                                    .split(/(?<=\.)\s*,\s*/g)
                                    .map((note, i) => {
                                      return (
                                        <>
                                          <div
                                            key={i}
                                            className={`matchText1 ${getDraggableClass(
                                              item.id,
                                              enableMatchText,
                                              droppedTextIds,
                                              item.footnotes,
                                            )}`}
                                            style={{
                                              display: "flex",

                                              alignItems: "center",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            <div
                                              style={{ whiteSpace: "nowrap" }}
                                              className="matchText1"
                                            >
                                              Footnotes
                                              {getSymbol(note.trim()) &&
                                                getSymbol(note.trim()) !==
                                                  "Not Assigned" && (
                                                  <>
                                                    <span
                                                      className="footnoteSymbol"
                                                      style={{
                                                        position: "relative",
                                                        left: "119.5px",
                                                        fontWeight: "bold",
                                                        whiteSpace: "nowrap",
                                                        paddingTop:
                                                          getSymbol(
                                                            note.trim(),
                                                          ) === "*"
                                                            ? "3px"
                                                            : "0px",
                                                      }}
                                                    >
                                                      {getSymbol(note.trim())}
                                                    </span>
                                                    {
                                                      <span
                                                        className="assignSymbolActive"
                                                        style={{
                                                          position: "relative",
                                                          left: "113.5px",
                                                          cursor:
                                                            droppedTextIds.includes(
                                                              item.id,
                                                            )
                                                              ? "not-allowed"
                                                              : "pointer",
                                                          fontSize: "12px",
                                                        }}
                                                        onClick={(e) => {
                                                          if (
                                                            droppedTextIds.includes(
                                                              item.id,
                                                            )
                                                          ) {
                                                            return;
                                                          }
                                                          e.stopPropagation();
                                                          setOpenQualifiersModal(
                                                            true,
                                                          );
                                                          setcurrentFootnoteText(
                                                            note.trim(),
                                                          );
                                                          // setcurrentSymbol(
                                                          //   getSymbol(
                                                          //     note.trim()
                                                          //   )
                                                          // );
                                                          setCurrentModuleIndex(
                                                            index,
                                                          );
                                                          setSelectedClaimIndex(
                                                            index,
                                                          );
                                                          setSelectedRelatedClaimIndex(
                                                            {
                                                              module: index,
                                                              sub: subIndex,
                                                            },
                                                          );
                                                          setExpandModuleQualifiers(
                                                            (prev) =>
                                                              prev.map(
                                                                (
                                                                  expanded,
                                                                  i,
                                                                ) =>
                                                                  i === index
                                                                    ? !expanded
                                                                    : false,
                                                              ),
                                                          );
                                                        }}
                                                      >
                                                        Edit Symbol
                                                      </span>
                                                    }{" "}
                                                  </>
                                                )}
                                            </div>{" "}
                                          </div>

                                          <div
                                            className={`noborderFootnote ${getDraggableClass(
                                              item.id,
                                              enableMatchText,
                                              droppedTextIds,
                                              item.footnotes,
                                            )}`}
                                            draggable={false}
                                            onDragStart={(e) => {
                                              const symbolPrefix =
                                                footnoteSymbols[footnoteKey]
                                                  ? `${footnoteSymbols[footnoteKey]} `
                                                  : "";
                                              sendAtomDetails2Canvas({
                                                id:
                                                  e.target.parentNode.id ||
                                                  e.target.id,
                                                type: "atomText",
                                                data:
                                                  symbolPrefix + item.footnotes,
                                                componentId:
                                                  component.componentId,
                                                moduleIdIdentifier:
                                                  currentModuleIdentifier,
                                              });
                                            }}
                                          >
                                            <div className="textvariant2">
                                              {note.trim()}
                                              {note.trim().endsWith(".")
                                                ? ""
                                                : "."}
                                            </div>
                                          </div>
                                        </>
                                      );
                                    })}
                                {item?.abbreviation?.length > 0 && (
                                  <>
                                    <div
                                      className="matchText1"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginLeft: "-4px",
                                      }}
                                    >
                                      Abbreviations
                                    </div>
                                    <div
                                      className={`noborderFootnote ${getDraggableClass(
                                        item.id,
                                        enableMatchText,
                                        droppedTextIds,
                                        item.footnotes,
                                      )}`}
                                      onDragStart={(e) =>
                                        sendAtomDetails2Canvas({
                                          id:
                                            e.target.parentNode.id ||
                                            e.target.id,
                                          type: "atomText",
                                          data: item.abbreviation,
                                          componentId: component.componentId,
                                          moduleIdIdentifier:
                                            currentModuleIdentifier,
                                        })
                                      }
                                    >
                                      <div
                                        className="textvariant2"
                                        style={{ paddingLeft: "4px" }}
                                      >
                                        {item?.abbreviation
                                          ?.split(";")
                                          .filter(
                                            (item1) => item1.trim() !== "",
                                          )
                                          .map((item1, index) => (
                                            <div key={index}>
                                              {item1.trim()}
                                            </div>
                                          ))}
                                      </div>
                                    </div>
                                  </>
                                )}
                                {item.references?.length > 0 && (
                                  <>
                                    <div
                                      className="matchText1"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      References
                                    </div>
                                    {item.references.map((ref, refIndex) => (
                                      <div
                                        key={refIndex}
                                        className={`noborderFootnote ${getDraggableClass(
                                          item.id,
                                          enableMatchText,
                                          droppedTextIds,
                                          item.footnotes,
                                        )}`}
                                        onDragStart={(e) =>
                                          sendAtomDetails2Canvas({
                                            id:
                                              e.target.parentNode.id ||
                                              e.target.id,
                                            type: "atomText",
                                            data: `${refIndex + 1}. ${
                                              ref.documentName
                                            }`,
                                            componentId: component.componentId,
                                            moduleIdIdentifier:
                                              currentModuleIdentifier,
                                          })
                                        }
                                      >
                                        <div className="textvariant2">
                                          {`${refIndex + 1}. ${
                                            ref.documentName
                                          }`}
                                        </div>
                                      </div>
                                    ))}
                                  </>
                                )}
                              </div>
                            )}
                          </div>
                        );
                      })}
                  </div>
                )}

                {/* Related Reusable Texts Section */}
                {component?.relatedReusableTexts?.length > 0 && (
                  <div className="related-section mt-2">
                    <div
                      className={`matchText collapsible-header ${
                        !canUseRelatedSections ? "disabledRelatedSection" : ""
                      }`}
                      style={{
                        opacity: canUseRelatedSections ? 1 : 0.4,
                        pointerEvents: canUseRelatedSections ? "auto" : "none",
                        cursor: canUseRelatedSections
                          ? "pointer"
                          : "not-allowed",
                      }}
                      onClick={(e) => {
                        if (!canUseRelatedSections) return;
                        e.stopPropagation();
                        setRelatedClaimExpand((prev) =>
                          prev === `reusables-${index}`
                            ? null
                            : `reusables-${index}`,
                        );
                        setNestedExpand([]);
                      }}
                    >
                      {relatedClaimExpand === `reusables-${index}` ? (
                        <span
                          className=" rcsAndrtsMinus expand-module"
                          style={{
                            fontSize: "30px",
                            backgroundColor: "rgb(240, 245, 248)",
                            color: "rgb(2, 2, 2)",
                            fontWeight: 100,
                            paddingBottom: "2px",
                          }}
                        >
                          -
                        </span>
                      ) : (
                        <span className=" rcsAndrtsplus">+</span>
                      )}
                      <span className="boldText" style={{ marginLeft: "6px" }}>
                        Related Reusable Texts
                      </span>
                      <span
                        style={{
                          marginLeft: "8px",
                          fontSize: "12px",
                          color: "#555",
                        }}
                      >
                        (items {component.relatedReusableTexts.length})
                      </span>

                      {!enableMatchText && isComponentNotdDropped && (
                        <div
                          className="tooltipRC"
                          onMouseEnter={handleMouseEnter}
                          onMouseLeave={handleMouseLeave}
                        >
                          <img
                            src={moduleWarning}
                            alt="warning"
                            style={{
                              width: "10px",
                              height: "10px",
                              display: "block",
                              marginTop: "4px",
                              marginLeft: "10px",
                            }}
                            className="warnImg"
                          />
                        </div>
                      )}
                      {contextMenu && isComponentNotdDropped && (
                        <>
                          <div className=" showTooltipRt d-flex">
                            <p>
                              To use Related Reusable Texts, first drag and drop
                              the image to the editor, then assign a symbol to
                              the footnotes
                            </p>
                          </div>
                          <div
                            class="contextMenuarrowRt"
                            id="contextMenuarrowRt"
                          ></div>
                        </>
                      )}
                    </div>
                    {/* Show related reusable texts if expanded */}
                    {relatedClaimExpand === `reusables-${index}` &&
                      component.relatedReusableTexts.map((item, subIndex) => {
                        const nestedKey = `reusables-${index}-${subIndex}`;
                        return (
                          <div key={subIndex} className="pl-3 mt-2">
                            <div
                              className="matchText collapsible-header"
                              style={{
                                opacity: isComponentNotdDropped ? "0.7" : "1",
                              }}
                              onClick={(e) => {
                                if (item?.mlrStatus === "Expired") {
                                  return;
                                }
                                if (!isComponentNotdDropped) {
                                  e.stopPropagation();
                                  setNestedExpand((prev) =>
                                    prev === nestedKey ? null : nestedKey,
                                  );
                                  if (item?.reusableTextName) {
                                    setExpandedChild(item?.reusableTextName);
                                  }
                                }
                              }}
                            >
                              {nestedExpand === nestedKey ? (
                                <span
                                  className=" rcsAndrtsMinus expand-module"
                                  style={{
                                    fontSize: "30px",
                                    backgroundColor: "rgb(240, 245, 248)",
                                    color: "rgb(2, 2, 2)",
                                    fontWeight: 100,
                                    paddingBottom: "2px",
                                  }}
                                >
                                  -
                                </span>
                              ) : (
                                <span className=" rcsAndrtsplus">+</span>
                              )}
                              {item && (
                                <>
                                  <div
                                    className="boldText d-flex"
                                    style={{ marginLeft: "4px" }}
                                  >
                                    <Tooltip
                                      title={
                                        item?.mlrStatus !== "Expired"
                                          ? "Available for use"
                                          : "Expired"
                                      }
                                      arrow
                                      classes={{
                                        popper: "toolTipClass2",
                                        tooltip: "toolTipClass2",
                                      }}
                                      placement="bottom-start"
                                    >
                                      <span>
                                        <img
                                          src={
                                            item?.mlrStatus !== "Expired"
                                              ? available
                                              : expiredStatus
                                          }
                                          className="img-fluid expiryIcon"
                                          alt=""
                                        />
                                      </span>
                                    </Tooltip>

                                    {item.reusableTextName}
                                  </div>
                                  <div
                                    className="parentModulebox"
                                    style={{
                                      backgroundColor: component?.mustUse
                                        ? "#E32B35"
                                        : "#378A05",
                                      marginLeft: "10px",
                                      marginTop: "2px",
                                    }}
                                  ></div>
                                </>
                              )}
                            </div>

                            {nestedExpand === nestedKey && item.matchText && (
                              <>
                                <div
                                  className={`matchText1 ${getDraggableClass(
                                    item.id,
                                    enableMatchText,
                                    droppedTextIds,
                                    item.footnotes,
                                  )}`}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: "38px",
                                    marginTop: "2px",
                                  }}
                                >
                                  Match Text
                                </div>
                                <div
                                  style={{ marginLeft: "21px" }}
                                  key={item.id}
                                  className={getDraggableClass(
                                    item.id,
                                    enableMatchText,
                                    droppedTextIds,
                                  )}
                                  draggable={
                                    enableMatchText &&
                                    !droppedTextIds?.includes(item.id)
                                  }
                                  onDragStart={(e) => {
                                    if (
                                      enableMatchText &&
                                      !droppedTextIds?.includes(item.id)
                                    ) {
                                      sendAtomDetails2Canvas({
                                        id: item.id,
                                        type: "atomText",
                                        data: item.matchText,
                                        subType: "DataGraphicText",
                                        matchTextId: item.id,
                                        componentId: component.componentId,
                                        subtype2: "relatedReusabletext",
                                        compReusableTexts: item.matchText,
                                        // reusableTextMatchText: item.matchText
                                        moduleIdIdentifier:
                                          currentModuleIdentifier,
                                      });
                                    }
                                  }}
                                >
                                  {enableMatchText &&
                                  !droppedTextIds?.includes(item.id) ? (
                                    <img
                                      src={sixDotIcon}
                                      alt=""
                                      className="img-fluid sixdotIcon"
                                    />
                                  ) : (
                                    <img
                                      src={sixDotIconGrayedOut}
                                      alt=""
                                      className="img-fluid sixdotIcon disImage"
                                    />
                                  )}
                                  <div className="textvariant2">
                                    {item.matchText}
                                  </div>
                                </div>
                                {Array.isArray(item.matchTextVariants) ? (
                                  item.matchTextVariants.map(
                                    (mtVariants, index) => {
                                      return (
                                        <>
                                          <div
                                            style={{
                                              marginTop: "8px",
                                              marginLeft: "35px",
                                            }}
                                            className={`matchText1 ${getDraggableClass(
                                              item.id,
                                              enableMatchText,
                                              droppedTextIds,
                                              item.footnotes,
                                            )}`}
                                          >
                                            {`Match Text Variant ${index + 1}`}
                                          </div>
                                          <div
                                            style={{ marginLeft: "18px" }}
                                            className={`${getDraggableClass(
                                              item.id,
                                              enableMatchText,
                                              droppedTextIds,
                                              item.footnotes,
                                            )}`}
                                            draggable={
                                              enableMatchText &&
                                              !droppedTextIds?.includes(item.id)
                                            }
                                            onDragStart={(e) => {
                                              if (
                                                enableMatchText &&
                                                !droppedTextIds?.includes(
                                                  item.id,
                                                )
                                              ) {
                                                sendAtomDetails2Canvas({
                                                  id: item.id,
                                                  type: "atomText",
                                                  data: mtVariants.matchText,
                                                  subType: "DataGraphicText",
                                                  matchTextId: item.id,
                                                  componentId:
                                                    component.componentId,
                                                  subtype2:
                                                    "relatedReusabletext",
                                                  compReusableTexts:
                                                    item.reusableTextId,
                                                  moduleIdIdentifier:
                                                    currentModuleIdentifier,
                                                });
                                              }
                                            }}
                                          >
                                            {enableMatchText &&
                                            !droppedTextIds?.includes(
                                              item.id,
                                            ) ? (
                                              <img
                                                src={sixDotIcon}
                                                alt=""
                                                className="img-fluid sixdotIcon"
                                              />
                                            ) : (
                                              <img
                                                src={sixDotIconGrayedOut}
                                                alt=""
                                                className="img-fluid sixdotIcon disImage"
                                              />
                                            )}
                                            <div className="textvariant2">
                                              {mtVariants.matchText}
                                            </div>
                                          </div>
                                          {index !==
                                            modulesArray.length - 1 && (
                                            <div className="borderLine"></div>
                                          )}
                                        </>
                                      );
                                    },
                                  )
                                ) : (
                                  <></>
                                )}
                              </>
                            )}
                          </div>
                        );
                      })}
                  </div>
                )}

                {index !== modulesArray.length - 1 && (
                  <div className="borderLine"></div>
                )}
              </>
            )}
          </>
        )}
      </div>
      {openFootnote && (
        <FootnoteSymbolModal
          symbolChangeTick={symbolChangeTick}
          setSymbolChangeTick={setSymbolChangeTick}
          openFootnote={openFootnote}
          onClose={handleCloseFootnoteModal}
          onSelectSymbol={handleSelectSymbol}
          currentFootnoteText={currentFootnoteText}
          currentSymbol={currentSymbol}
          usedSymbols={usedSymbols}
          setusedSymbols={setusedSymbols}
        />
      )}
      {openQualifiersModal && (
        <QualifiersModal
          selectedClaimIndex={selectedClaimIndex}
          setSelectedClaimIndex={setSelectedClaimIndex}
          selectedRelatedClaimIndex={selectedRelatedClaimIndex}
          setSelectedRelatedClaimIndex={setSelectedRelatedClaimIndex}
          expandModule={expandModuleQualifiers}
          setExpandModule={setExpandModuleQualifiers}
          textSymbolMap={textSymbolMap}
          areAllFootnotesAssigned={areAllFootnotesAssigned}
          areAllFootnotesAssignedForModule={areAllFootnotesAssignedForModule}
          symbolChangeTick={symbolChangeTick}
          setSymbolChangeTick={setSymbolChangeTick}
          readTextSymbolMap={readTextSymbolMap}
          allSymbolsAssigned={allSymbolsAssigned}
          setAllSymbolsAssigned={setAllSymbolsAssigned}
          setTextSymblMapTemp={setTextSymblMapTemp}
          handleQualifiersModal={handleQualifiersModal}
          handleCloseQualifiersModal={handleCloseQualifiersModal}
          openQualifiersModal={openQualifiersModal}
          modulesArrayData={modulesArray}
          expand={expand}
          claim={claim}
          component={component}
          onSelectSymbol={handleSelectSymbol}
          currentFootnoteText={currentFootnoteText}
          currentSymbol={currentSymbol}
          currentModuleIndex={currentModuleIndex}
          setCurrentModuleIndex={setCurrentModuleIndex}
          setcurrentSymbol={setcurrentSymbol}
          usedSymbols={usedSymbols}
          setusedSymbols={setusedSymbols}
          setClaimAssignClicked={setClaimAssignClicked}
          claimAssignClicked={claimAssignClicked}
          componentAssignClicked={componentAssignClicked}
          setComponentAssignClicked={setComponentAssignClicked}
        />
      )}
    </>
  );
};

export default AssociatedCard;
